<template>
  <div class="shop" v-loading="loading">
    <div class="top">
      <el-date-picker
        v-model="form.active_time"
        type="date"
        style="width: 136px; margin-right: 10px"
        value-format="yyyy-MM-dd"
        size="mini"
        placeholder="激活开始时间"
      >
      </el-date-picker>

      <el-date-picker
        v-model="form.bind_time"
        type="date"
        style="width: 136px; margin-right: 10px"
        value-format="yyyy-MM-dd"
        size="mini"
        placeholder="激活结束时间"
      >
      </el-date-picker>
      <el-date-picker
        v-model="form.start_time"
        type="date"
        style="width: 136px; margin-right: 10px"
        size="mini"
        value-format="yyyy-MM-dd"
        placeholder="开始授权时间"
      ></el-date-picker>
      <el-date-picker
        v-model="form.end_time"
        type="date"
        style="width: 136px; margin-right: 10px"
        size="mini"
        value-format="yyyy-MM-dd"
        placeholder="结束授权时间"
      ></el-date-picker>
      <el-select
        size="mini"
        v-model="form.saler_name"
        style="width: 160px; margin-right: 10px"
        placeholder="是否授权销售"
      >
        <el-option value="1" label="是"></el-option>
        <el-option value="2" label="否"></el-option>
      </el-select>
      <!-- <el-select
        size="mini"
        v-model="form.all_box"
        style="width:160px;margin-right:10px;"
        placeholder="是否整盒卡"
      >
        <el-option value="1" label="是"></el-option>
        <el-option value="2" label="否"></el-option>
      </el-select> -->
      <el-select
        size="mini"
        v-model="form.card_amount"
        style="width: 160px; margin-right: 10px"
        placeholder="选择购卡面值"
      >
        <!-- <el-option value="" label="全部面值"></el-option> -->
        <el-option value="3" label="3"></el-option>
        <el-option value="5" label="5"></el-option>
        <el-option value="10" label="10"></el-option>
        <el-option value="50" label="50"></el-option>
        <el-option value="60" label="60"></el-option>
        <el-option value="100" label="100"></el-option>
        <el-option value="200" label="200"></el-option>
        <el-option value="500" label="500"></el-option>
        <el-option value="1000" label="1000"></el-option>
        <el-option value="10000" label="10000"></el-option>
        <el-option value="50000" label="50000"></el-option>
        <el-option value="100000" label="100000"></el-option>
      </el-select>
      <el-select
        size="mini"
        v-model="form.payment_method"
        style="width: 160px; margin-right: 10px"
        placeholder="付款方式"
      >
        <!-- <el-option value="" label="全部面值"></el-option> -->
        <el-option value="3" label="现销">现销</el-option>
        <el-option value="4" label="赊销">赊销</el-option>
        <el-option value="5" label="代销">代销</el-option>
        <el-option value="6" label="赠送">赠送</el-option>
      </el-select>
      <el-input
        class="search input"
        size="small"
        v-model="form.box_sn"
        placeholder="盒ID"
        clearable
      ></el-input>
      <el-button class="search" size="small" type="primary" @click="searchList"
        >搜索</el-button
      >
      <el-button size="small" type="primary" @click="exportWoods"
        >导出数据</el-button
      >
      <el-button size="small" type="primary" @click="exportCards"
        >导出卡片</el-button
      >
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="box_id"></el-table-column>
      <el-table-column label="盒ID" prop="box_sn"></el-table-column>
      <el-table-column label="面值" prop="card_amount"></el-table-column>
      <el-table-column label="激活时间" prop="active_time"></el-table-column>
      <el-table-column label="授权销售" prop="saler_name"></el-table-column>
      <el-table-column label="授权时间" prop="bind_time"></el-table-column>
      <el-table-column label="成本价" prop="money"></el-table-column>
      <el-table-column
        label="付款方式"
        prop="payment_method_name"
      ></el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <el-table-column
        label="是否实体卡"
        prop="make_cards_name"
      ></el-table-column>
      <el-table-column label="激活张数" prop="count_card"></el-table-column>
      <el-table-column label="使用张数" prop="use_num"></el-table-column>
      <!-- <el-table-column label="使用情况" prop="remarks"></el-table-column> -->
      <el-table-column label="操作" fixed="right" width="300">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-if="scope.row.status != 1"
            @click="toPromoter(scope.row.box_id)"
            >授权BC推广员</el-button
          >
          <el-button size="mini" @click="toCheck(scope.row.box_id)"
            >查看</el-button
          >
          <el-button
            size="mini"
            v-if="!scope.row.active_time"
            @click="toActivation(scope.row.box_id, scope.row.card_num)"
            >激活</el-button
          >
          <el-button size="mini" @click="remarkItem(scope.row)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!--添加弹窗-->
    <jdialog
      title="选择授权的BC推广员"
      :visible.sync="promoterBox"
      width="400px"
    >
      <div class="promoter-con">
        <!-- <el-select
          size="mini"
          placeholder="选择授权的BC推广员"
          style="display:block;width:200px;margin:0 auto;"
          v-model="promoterInfo.id"
        >
          <el-option
            v-for="item in promoterData"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select> -->
        <!-- <el-autocomplete
          style="display: block; width: 200px; margin: 0 auto"
          popper-class="my-autocomplete"
          v-model="state"
          :fetch-suggestions="querySearch"
          placeholder="选择授权的BC推广员"
          @select="handleSelect"
        >
          <template slot-scope="{ item }">
            <div class="name">{{ item.name }}</div>
          </template>
        </el-autocomplete> -->
        <el-input
          class="input"
          size="small"
          v-model="promoterInfo.mobile"
          placeholder="请输入授权的BC推广员"
          clearable
        ></el-input>
      </div>
      <div class="align">
        <el-button
          class="sure"
          size="mini"
          type="primary"
          @click="toGrantguthorization"
          >确定</el-button
        >
      </div>
    </jdialog>
    <!--激活-->
    <jdialog
      :title="'是否激活此盒卡，共' + boxActivationNum + '张'"
      :visible.sync="activationBox"
      width="400px"
    >
      <div class="activation-con"></div>
      <div class="align">
        <el-button size="mini" @click="activationBox = false">取消</el-button>
        <el-button
          class="sure"
          size="mini"
          type="primary"
          @click="setActivation"
          >确定</el-button
        >
      </div>
    </jdialog>
    <!--备注弹窗-->
    <jdialog title="备注" :visible.sync="isShowRemarkWindow" width="640px">
      <el-form
        :model="remarkWindowInfo"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="120px"
      >
        <el-form-item label="选择付款方式">
          <el-radio v-model="remarkWindowInfo.payment_method" label="3"
            >现销</el-radio
          >
          <el-radio v-model="remarkWindowInfo.payment_method" label="4"
            >赊销</el-radio
          >
          <el-radio v-model="remarkWindowInfo.payment_method" label="5"
            >代销</el-radio
          >
          <el-radio v-model="remarkWindowInfo.payment_method" label="6"
            >赠送</el-radio
          >
        </el-form-item>

        <el-form-item label="备注">
          <el-input
            style="width: 500px"
            type="text"
            placeholder="备注"
            v-model="remarkWindowInfo.remarks"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowRemarkWindow = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click="creatRemark"
          >确定</el-button
        >
      </div>
    </jdialog>
    <!--导出卡片弹窗-->
    <jdialog title="导出卡片" :visible.sync="exportCardsShow" width="640px">
      <el-form
        :model="exportCardsForm"
        ref="ruleForm"
        class="demo-ruleForm export-window"
        label-width="120px"
      >
        <el-date-picker
          v-model="exportCardsForm.start_time"
          type="date"
          style="width: 136px; margin-right: 10px"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="开始导出时间"
        ></el-date-picker>
        <el-date-picker
          v-model="exportCardsForm.end_time"
          type="date"
          style="width: 136px; margin-right: 10px"
          size="mini"
          value-format="yyyy-MM-dd"
          placeholder="结束导出时间"
        ></el-date-picker>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="exportCardsShow = false">取消</el-button>
        <el-button size="mini" type="primary" @click="creatExportCards"
          >确定</el-button
        >
      </div>
    </jdialog>
  </div>
</template>

<script>
import {
  getBox,
  // getAll,
  toGrantguthorization,
  setActivation,
  creatRemark,
  cardListExport
} from '@/api/redpacket'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      loading: false,
      state: '',
      form: {
        start_time: '',
        end_time: '',
        active_time: '',
        bind_time: '',
        saler_name: '',
        all_box: '',
        card_amount: '',
        payment_method: '',
        box_sn: '',
        make_cards_name: '',
        page: 1,
        size: 10
      },
      tableData: [],
      restaurants: [],
      labelPosition: 'right',
      promoterBox: false,
      activationBox: false,
      is_export: 0, //0非导出，1导出
      total: 0,
      promoterInfo: {
        mobile: '',
        box_id: ''
      },
      boxActivationId: '',
      boxActivationNum: '',
      isShowRemarkWindow: false,
      remarkWindowInfo: {
        box_id: '',
        payment_method: '',
        remarks: ''
      },
      exportCardsShow: false, // 导出卡片弹窗
      exportCardsForm: {
        start_time: '',
        end_time: '',
        page: 1,
        filename: ''
      }
    }
  },
  mounted() {
    this.getBoxList()
    // this.getAllList()
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      // console.log(results)
      cb(results)
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    // handleSelect(item) {
    //   this.state = item.name
    //   this.promoterInfo.id = item.id
    // },
    //获取列表数据
    async getBoxList() {
      let {
        active_time,
        bind_time,
        start_time,
        end_time,
        saler_name,
        all_box,
        card_amount,
        payment_method,
        box_sn,
        page,
        size
      } = this.form
      let url = `card_amount=${card_amount}&active_time=${active_time}&bind_time=${bind_time}&start_time=${start_time}&end_time=${end_time}&saler_name=${saler_name}&all_box=${all_box}&page=${page}&size=${size}&payment_method=${payment_method}&box_sn=${box_sn}&is_export=${this.is_export}`
      let res = await getBox(url)
      console.log(res)
      if (res.code === 10000) {
        if (this.is_export == 1) {
          this.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          )
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.is_export = 0
        this.$message.error(res.message)
      }
    },
    // 获取授权推广员列表
    // async getAllList() {
    //   let res = await getAll('')
    //   console.log(res)
    //   if (res.code === 10000) {
    //     this.restaurants = res.data
    //   } else {
    //     this.$message.error(res.message)
    //   }
    // },
    // 确认授权推广员
    async toGrantguthorization() {
      let res = await toGrantguthorization(this.promoterInfo)
      console.log(res)
      if (res.code === 10000) {
        console.log(res)
        this.$message.success(res.message)
        this.promoterBox = false
        this.getBoxList()
      } else {
        this.promoterBox = false
        this.$message.error(res.message)
      }
    },
    //激活
    async setActivation() {
      let res = await setActivation({ box_id: this.boxActivationId })
      console.log(res)
      if (res.code === 10000) {
        console.log(res)
        this.$message.success(res.message)
        this.activationBox = false
        this.getBoxList()
      } else {
        this.activationBox = false
        this.$message.error(res.message)
      }
    },
    //导出
    exportWoods() {
      this.is_export = 1
      this.getBoxList()
    },
    //搜索
    searchList() {
      this.getBoxList()
    },
    // 跳转查看卡
    toCheck(id) {
      this.$router.push({
        path: './lookRedCard',
        query: { box_id: id }
      })
    },
    //显示添加弹窗
    toPromoter(box_id) {
      console.log(box_id)
      this.promoterBox = true
      this.promoterInfo.box_id = box_id
    },
    //显示添加弹窗
    toActivation(box_id, num) {
      console.log(box_id, num)
      this.activationBox = true
      this.boxActivationId = box_id
      this.boxActivationNum = num
    },
    //显示备注弹窗
    remarkItem(info) {
      console.log(typeof info.payment_method)
      this.remarkWindowInfo.box_id = info.box_id
      this.remarkWindowInfo.payment_method = info.payment_method
      this.remarkWindowInfo.remarks = info.remarks
      this.isShowRemarkWindow = true
    },
    //确认备注
    async creatRemark() {
      let res = await creatRemark(this.remarkWindowInfo)
      if (res.code === 10000) {
        this.getBoxList()
        this.$message.success(res.message)
        this.isShowRemarkWindow = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getBoxList()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
    //导出卡片
    exportCards() {
      this.exportCardsForm.start_time = ''
      this.exportCardsForm.end_time = ''
      this.exportCardsShow = true
    },
    //确认导出卡片
    creatExportCards() {
      this.exportCardsShow = false
      this.getCardList()
    },
    //获取列表数据
    async getCardList() {
      let { start_time, end_time, page, filename } = this.exportCardsForm
      let url = `start_time=${start_time}&end_time=${end_time}&page=${page}&filename=${filename}`
      let res = await cardListExport(url)
      console.log(res)
      if (res.code === 2) {
        this.exportCardsForm.filename = res.filename
        this.loading = true
        this.exportOut(res.page, res.filename)
        return
      } else {
        this.$message.error(res.message)
      }
    },
    async exportOut(page, filename) {
      let { start_time, end_time } = this.exportCardsForm
      let url = `start_time=${start_time}&end_time=${end_time}&page=${page}&filename=${filename}`
      let res = await cardListExport(url)
      if (res.code === 2) {
        this.exportOut(res.page, res.filename)
      } else if (res.code === 1) {
        this.loading = false
        window.open(`${API_BASE_URL}/admin/download/zip/${res.download_token}`)
      } else {
        this.loading = false
        this.$message.error(res.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-date-editor,
.el-input {
  margin-bottom: 10px;
}
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top {
    margin-bottom: 20px;
    .input {
      width: 150px;
      margin-right: 10px;
    }
  }
  .align {
    text-align: center;
    .sure {
      width: 200px;
    }
  }
  .promoter-con {
    padding: 30px;
  }
  .activation-con {
    padding: 30px;
  }
  ::v-deep.dialog {
    .title {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
    }
  }
  .export-window {
    display: flex;
    justify-content: space-evenly;
    margin-top: 30px;
    margin-bottom: 25px;
  }
}
</style>
